import React from "react";
import { DEFAULT_TITLE_COLOR, TITLE_COLOR_PRESETS } from "../utils/titleColors";

export default function TitleColorField({
  label = "Title color",
  value = DEFAULT_TITLE_COLOR,
  onChange,
}) {
  const currentValue = value || DEFAULT_TITLE_COLOR;

  return (
    <div className="editor-field title-color-field">
      <span>{label}</span>
      <div className="title-color-row">
        <input
          type="color"
          value={currentValue}
          onChange={(event) => onChange?.(event.target.value)}
          aria-label={label}
        />
        <button
          type="button"
          className="action-button action-button-secondary title-color-default"
          onClick={() => onChange?.(DEFAULT_TITLE_COLOR)}
        >
          Default
        </button>
        <span className="group-color-chip">
          <span style={{ background: currentValue }} />
          {currentValue === DEFAULT_TITLE_COLOR ? "Default" : currentValue}
        </span>
      </div>
      <div className="title-color-presets" aria-label="Saved title colors">
        {TITLE_COLOR_PRESETS.map((preset) => (
          <button
            key={preset.value}
            type="button"
            className={`title-color-swatch ${currentValue === preset.value ? "is-active" : ""}`}
            onClick={() => onChange?.(preset.value)}
            title={`${preset.label}: ${preset.value}`}
            aria-label={`${preset.label} color`}
            style={{ background: preset.value }}
          />
        ))}
      </div>
    </div>
  );
}
